import { useMemo } from 'react';
import get from 'lodash/get';
import Highcharts from 'highcharts';
import { makeObjectOutOfArrays } from '../../../../../containers/Overview/utils';

const useTransformNPSData = (item, timeperiodLabel) => {
    return useMemo(() => {
        const npsSubtitle = `${timeperiodLabel}: Likelihood to Recommend (0-10)`;
        const metric_count = get(item, 'cstData.metric_count');
        const npsLowSampleSize = get(item, 'lowSampleSize');
        const isNpsLowSampleSize = get(metric_count, '[0][0]') < npsLowSampleSize;

        const npsColumns = get(item, 'cstData.columns');
        const npsMetricData = get(item, 'cstData.metric_data');
        const npsDataObj = makeObjectOutOfArrays(npsColumns, get(npsMetricData, '[0]'));

        const value = get(npsDataObj, 'promoter_percentage') - get(npsDataObj, 'detractor_percentage');
        const benchmarkAverageNps = get(npsDataObj, 'benchmark_average_nps');
        const subLabelValue = (value - benchmarkAverageNps)?.toFixed(2);
        const subLabel = `${subLabelValue > 0 ? '+' : '-'}  ${subLabelValue}`;

        const defaultOptions = get(item, 'data');
        const indicatorSegments = get(defaultOptions, 'indicatorSegments', []);

        const extraConfig = {
            centerLabel: {
                label: value,
                subLabel: subLabel
            },
            indicatorSegments: [{ ...indicatorSegments[0], value: value || 0 }]
        };

        const options = Highcharts.merge(defaultOptions, extraConfig);

        return {
            npsSubtitle,
            isNpsLowSampleSize,
            npsLowSampleSize,
            options,
            npsDataObj
        };
    }, [item, timeperiodLabel]);
};

export default useTransformNPSData;